/**
 * The attribution and copyright line that closes a public page.
 *
 * A component rather than two lines of markup because it appears on every screen somebody
 * can reach without signing in — the login page, the external share view, the signing page
 * — and a copyright notice that says one thing in one place and something else in another
 * is worse than none.
 *
 * The year is computed, not written. A hard-coded year is correct for a few months and
 * quietly wrong for the rest of the product's life, and nobody ever notices the day it
 * turns; this file already replaced two hard-coded statistics for the same reason.
 */
export default function LegalFooter({ tone = 'light', className, style }) {
  const dark = tone === 'dark';
  return (
    <div
      className={className}
      style={{
        textAlign: 'center',
        fontSize: 11.5,
        lineHeight: 1.7,
        color: dark ? 'rgba(255,255,255,.45)' : 'var(--faint, #94a3b8)',
        ...style,
      }}
    >
      <div>Powered by Inditech Technologies LLC</div>
      <div>© {new Date().getFullYear()} Inditech Document Hub. All rights reserved.</div>
    </div>
  );
}
